import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://509f40aed41b9dbe49c1180c27acb497@o4511480901009408.ingest.us.sentry.io/4511481646481408",
  debug: false,
  environment: "production",
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});